import GA_EVENTS from '../ga_constants';
import { setBehaviourEvent } from '../ga_interface';

function changeSpecific(filtersToChange) {
    const category = GA_EVENTS.catalogStatusbar.category;
    const action = GA_EVENTS.catalogStatusbar.actions.changeSpecific;
    const label = filtersToChange.join(', ');

    setBehaviourEvent({ category, action, label });
}

function addMissing(filtersToAdd) {
    const category = GA_EVENTS.catalogStatusbar.category;
    const action = GA_EVENTS.catalogStatusbar.actions.addMissing;
    const label = filtersToAdd.join(', ');

    setBehaviourEvent({ category, action, label });
}

export {
    changeSpecific,
    addMissing
};